class CartDiscountCode extends HTMLElement {
  connectedCallback() {
    this._input   = this.querySelector('#CartDrawer-DiscountInput');
    this._button  = this.querySelector('#CartDrawer-DiscountApply');
    this._message = this.querySelector('#CartDrawer-DiscountMessage');

    this._button.addEventListener('click', () => this.applyCode());
    this._input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); this.applyCode(); }
    });
    this._input.addEventListener('input', () => {
      if (this._input.dataset.state === 'error') this._clearMessage();
    });
  }

  async applyCode() {
    const code = this._input.value.trim();
    if (!code) return;
    this._setLoading(true);

    try {
      // Apply discount — sets a session cookie; response is always opaque
      await fetch(`/discount/${encodeURIComponent(code)}`, { redirect: 'manual' });

      // Verify by checking cart_level_discount_applications
      const cart = await fetch('/cart.js').then(r => r.json());
      const applied = (cart.cart_level_discount_applications || [])
        .some(d => d.title.toLowerCase() === code.toLowerCase());

      if (applied) {
        await this._rerenderPrices();
        this._showSuccess(code);
      } else {
        this._showError('That code is not valid.');
      }
    } catch {
      this._showError('That code is not valid.');
    } finally {
      this._setLoading(false);
    }
  }

  async _removeCode() {
    this._setLoading(true);
    try {
      // Applying an empty discount clears the active code from the session
      await fetch('/discount/', { redirect: 'manual' });
      await this._rerenderPrices();
    } finally {
      this._setLoading(false);
    }
    this._showIdle();
  }

  async _rerenderPrices() {
    const res    = await fetch(`${window.routes.cart_url}?section_id=cart-drawer`);
    const text   = await res.text();
    const parsed = new DOMParser().parseFromString(text, 'text/html');

    const srcDiscounts = parsed.querySelector('#CartDrawer-Discounts');
    const dstDiscounts = document.querySelector('#CartDrawer-Discounts');
    if (srcDiscounts && dstDiscounts) dstDiscounts.replaceWith(srcDiscounts);

    const srcTotal = parsed.querySelector('#CartDrawer-Total');
    const dstTotal = document.querySelector('#CartDrawer-Total');
    if (srcTotal && dstTotal) dstTotal.replaceWith(srcTotal);
  }

  _showSuccess(code) {
    this._input.value         = code.toUpperCase();
    this._input.readOnly      = true;
    this._input.dataset.state = 'success';
    this._message.textContent = 'Code applied \u2713';
    this._message.dataset.type = 'success';
    this._message.hidden      = false;
    this._button.textContent  = 'Remove';
    this._button.setAttribute('aria-label', `Remove discount code ${code}`);
    this._button.onclick      = (e) => { e.preventDefault(); this._removeCode(); };
  }

  _showError(text) {
    this._input.dataset.state  = 'error';
    this._message.textContent  = text;
    this._message.dataset.type = 'error';
    this._message.hidden       = false;
    this._input.setAttribute('aria-invalid', 'true');
  }

  _showIdle() {
    this._input.value         = '';
    this._input.readOnly      = false;
    this._input.dataset.state = 'idle';
    this._button.textContent  = 'Apply';
    this._button.setAttribute('aria-label', 'Apply discount code');
    this._button.onclick      = null;
    this._clearMessage();
  }

  _clearMessage() {
    this._message.hidden = true;
    this._message.textContent = '';
    delete this._message.dataset.type;
    this._input.removeAttribute('aria-invalid');
  }

  _setLoading(on) {
    this._button.disabled = on;
    this._input.disabled  = on;
  }
}

customElements.define('cart-discount-code', CartDiscountCode);
